// Trạng thái Dashboard Telesales. cfg đồng bộ với server qua settingsApi; phần còn lại lưu localStorage, chờ API
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import dayjs from 'dayjs';
import type { Mang } from '../components/Types';
import { DEFAULT_CFG, type ApptPatch, type Cfg, type Period } from './logic';

export type View = 'ops' | 'agent' | 'branch' | 'balance';
export interface LogEntry { at: number; text: string }

interface DashState {
  view: View;
  /** Bộ lọc màn Quản lý */
  period: Period;
  mang?: Mang;
  branchFilter?: string;
  /** Màn Nhân viên Telesales */
  agentId: string;
  /** Màn Tư vấn cơ sở */
  branchId: string;
  consultantId?: string;
  cfg: Cfg;
  /** Ngày + thời điểm mở dashboard lần đầu trong ngày; đổi ngày thì xoá thao tác cũ */
  seed: { date: string; at: number };
  appt: Record<string, ApptPatch>;
  done: Record<string, number>;
  assign: Record<string, string>;
  log: LogEntry[];
  set: (p: Partial<Pick<DashState, 'view' | 'period' | 'mang' | 'branchFilter' | 'agentId' | 'branchId' | 'consultantId'>>) => void;
  setCfg: (cfg: Cfg) => void;
  ensureSeed: () => void;
  patchAppt: (id: string, p: ApptPatch) => void;
  markDone: (key: string) => void;
  undoDone: (key: string) => void;
  reassign: (key: string, agentId: string) => void;
  addLog: (text: string) => void;
}

const today = () => dayjs().format('YYYY-MM-DD');

const useTeleDash = create<DashState>()(persist((set, get) => ({
  view: 'ops',
  period: 'month',
  agentId: 'NV-03',
  branchId: 'q1',
  cfg: DEFAULT_CFG,
  seed: { date: today(), at: Date.now() },
  appt: {},
  done: {},
  assign: {},
  log: [],
  set: p => set(p),
  setCfg: cfg => set({ cfg }),
  ensureSeed: () => {
    if (get().seed.date !== today()) set({ seed: { date: today(), at: Date.now() }, appt: {}, done: {}, assign: {}, log: [] });
  },
  patchAppt: (id, p) => set(s => ({ appt: { ...s.appt, [id]: { ...s.appt[id], ...p, updatedAt: Date.now() } } })),
  markDone: key => set(s => ({ done: { ...s.done, [key]: Date.now() } })),
  undoDone: key => set(s => {
    const done = { ...s.done };
    delete done[key];
    return { done };
  }),
  reassign: (key, agentId) => set(s => ({ assign: { ...s.assign, [key]: agentId } })),
  addLog: text => set(s => ({ log: [{ at: Date.now(), text }, ...s.log].slice(0, 50) })),
}), {
  name: 'khothi-tele-dashboard-v1',
  version: 2,
  // v2: kỳ mặc định chuyển sang "Tháng này" (phễu hôm nay chưa có khách đến / chốt)
  migrate: s => ({ ...(s as DashState), period: 'month' }),
}));

export default useTeleDash;
